import * as Yup from "yup";
import i18next from "i18next";

const t = i18next.t;

export const validationSchema = Yup.object({
  email: Yup.string()
    .email(t("signIn.validation.email.invalid"))
    .required(t("signIn.validation.email.required")),
  password: Yup.string()
    .min(8, t("signIn.validation.password.min"))
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/,
      t("signIn.validation.password.pattern"),
    )
    .required(t("signIn.validation.password.required")),
});
